<div class="filter-list">
  <div class="filter-list__header flex flex-align-center flex-justify-space-between">
    <span class="filter-list__title">{{ props.label }}</span>
    <app-button variant="outlined" size="sm" (click)="add()" data-testid="filter-add-button">
      <app-icon name="plus" [size]="14" />
      {{ 'reports.builder.filters.add' | translate }}
    </app-button>
  </div>

  @for (row of field.fieldGroup; track row.id || $index; let i = $index) {
  <div class="filter-list__row flex flex-align-center gap-sm" [attr.data-testid]="'filter-row-' + i">
    <formly-field class="filter-list__cell" [field]="row.fieldGroup![0]" />
    <formly-field class="filter-list__cell" [field]="row.fieldGroup![1]" />
    <formly-field class="filter-list__cell" [field]="row.fieldGroup![2]" />
    <app-button variant="icon" size="sm" color="danger" (click)="remove(i)"
      [attr.data-testid]="'filter-remove-' + i">
      <app-icon name="trash" [size]="14" />
    </app-button>
  </div>
  }

  @if (!field.fieldGroup?.length) {
  <div class="filter-list__empty" data-testid="filter-empty">
    {{ 'reports.builder.filters.empty' | translate }}
  </div>
  }
</div>
